module.exports = __webpack_public_path__ + "static/media/support-graph.70d3e6a0.png";